import Footer from '@/components/Footer';
import Header from '@/components/Header';
import ContactUs from '@/components/Relation/ContactUs';
import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';


const ContactUsPage: NextPage = () => {

  return (
    <>
      <NextSeo
        title='Green Parenting | Contact Us'
        canonical={process.env.NEXT_PUBLIC_HOSTNAME + "/contact-us"}
        openGraph={{
          images: [{
            url: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/contact-us-desktop.jpg",
            width: 900,
            height: 922,
            alt: 'Green Parenting Contact Us image',
          }]
        }}
      />
      <Header />
      <ContactUs />
      <Footer />
    </>
  )
}

export default ContactUsPage
